<template>
  <div class="card-loteFrete-gerar-novo-pedido">
    <!-- <div class="titulo-fluxos">INFORMAÇÕES SOBRE O FRETE</div>
    <div class="subtitulo-fluxos">Forneça informações sobre a entrega</div> -->

    <g-titulo-steps
    titulo="INFORMAÇÕES SOBRE O FRETE"
    subtitulo="Forneça informações sobre a entrega"
    :imagemEmpresa = imagemEmpresa
    />
    
  </div>
  <g-form class="espacamento-fluxos">
      <div>
        <div class="frete-campo">
          <div class="frete">
            <label class="titulo-conteudo-fluxos">Frete</label>
            <PInputText disabled="true" v-model="indicadorDeTipoFreteText"></PInputText>
          </div>
          

          <div class="cidadeestado">
            <div class="uf">
              <label class="titulo-conteudo-fluxos">UF</label>
              <PInputText :disabled="desativa" v-model="siglaEstado"></PInputText>
            </div>
            

            <div class="cidade">
              <label class="titulo-conteudo-fluxos">Cidade</label>
              <PInputText :disabled="desativa" v-model="nomeCidade"></PInputText>
            </div>
          </div>
          <div class="transportadora">
            <label :disabled="desativa" class="titulo-conteudo-fluxos">Transportadora</label>
            <PDropDown
            class="input"
            :disabled="desativaTransporte"
            :options="TransportadoraArray"
            optionLabel="nomeTransportadora"
            optionValue="id"
            placeholder="Selecione a Transportadora"
            v-model="transportadoraSelecionada"
            emptyMessage="Pesquise a transportadora desejada"
            :filter="true"
            @filter="buscarTransportadoras($event.value)"
            @change="TrazerInfosTransportadora()"
            >
            <template #option="slotProps">
              <transportadora-dropdown-item :transportadora="slotProps.option"></transportadora-dropdown-item>
            </template>
          
          </PDropDown>
          </div>


          <div class="endereco">
            <label class="titulo-conteudo-fluxos">Endereco</label>
            <PInputText :disabled="desativa" v-model="nomeEndereco"></PInputText>
          </div>


          <div class="cep">
            <label class="titulo-conteudo-fluxos">CEP</label>
            <PInputText :disabled="desativa" v-model="cep"></PInputText>
          </div>


          <div class="bairro-campo">
            <div class="bairro">
              <label class="titulo-conteudo-fluxos">Bairro</label>
              <PInputText :disabled="desativa" v-model="bairro"></PInputText>
            </div>
          </div>

          <div class="complemento">
            <label class="titulo-conteudo-fluxos">Complemento</label>
            <PInputText :disabled="desativa" v-model="complemento">{{clienteId}}</PInputText>
          </div>
        </div>
      </div>

      <div id="EsconderEnderecoDiferenteFaturamento">
        <div class="container-cliente-endereco">
          <div class="option-sim-nao">
            <div class="endereco-entrega">Endereço de entrega é diferente do faturamento?
                <div class="radioButton-container">
                    <div class="radiobutton-item">
                      <PRadioButton
                        :binary="true"
                        class="radio"
                        :value="1"
                        name="botaoSim"
                        v-model="botaoSimENao"

                      ></PRadioButton>
                      <label class="radioButton-label">Sim</label>

                    </div>
                    <div class="radiobutton-item">
                      <PRadioButton
                        :binary="true"
                        class="radio"
                        :value="0"
                        name="botaoNao"
                        v-model="botaoSimENao"
                      ></PRadioButton>
                      <label class="radioButton-label">Não</label>
                    </div>
                </div>
            </div>
          </div>
          <div class="cliente-endereco">
            <div class="cliente-info" v-if="this.botaoSimENao">
                  <!-- <div class="cod-cliente">
                    <label class="titulo-conteudo-fluxos">Cód. Cliente</label>
                    <PInputText
                      class="input"
                      disabled
                      :options="cartaArray"
                       optionLabel="text"
                       optionValue="id"
                       v-model="codigoSelecionado"
                    ></PInputText>
                  </div> -->

                  <div class="nome-cliente">
                    <label class="titulo-conteudo-fluxos">Busque o Cliente</label>
                    <!-- <PDropDown
                      class="input"
                      :filter="true"
                      :options="clienteByCidadeArray"
                      optionLabel="razaoSocial"
                      optionValue="enderecoId"
                      v-model="enderecoIdClienteSelecionado"
                      @change="(selecionaCodigo(enderecoIdClienteSelecionado))"
                    ></PDropDown> -->
                    <PDropDown
                      class="p-dropdown"
                      v-model="enderecoIdClienteSelecionado"
                      :options="ClientesArray"
                      optionLabel="nomeFantasia"
                      :filterFields="[
                        'razaoSocial',
                        'codigoExterno',
                        'nomeFantasia',
                        'situacao',
                        'estadoCidade',
                        'cnpj',
                      ]"
                      :filter="true"
                      optionValue="codigoExterno"
                      placeholder="Selecione o Cliente"
                      @filter="buscarClientes($event.value)"
                    >
                      <template #option="slotProps">
                        <cliente-dropdown-item
                          :dadosCliente="slotProps.option"
                        ></cliente-dropdown-item>
                      </template>
                    </PDropDown>


                  </div>

                  <!-- <div class="editar-button">
                    <g-button
                    class="btn-editar"
                    altura="35px"
                    largura="35px"
                    tamanhoIcone="20px"
                    icone="icone_editar.svg"
                    @click="abrePopup"
                    >
                    </g-button>
                  </div> -->
              </div>
          </div>
        </div>
      </div>

    </g-form>

    <div class="buttons-next-back">
      <div class="button-next">
        <g-button 
        tipo="amarelo"
        altura="35px"
        largura="100%"
        negritoTexto  
        @click="Continuar()"
        ref="botaoContinuar"
        > 
          CONTINUAR 
        </g-button>
      </div>
      <div class="button-back">
        <g-button 
        tipo="cinza" 
        altura="35px"
        largura="100%"
        negritoTexto  
        @click="Voltar()"
        > 
          VOLTAR 
        </g-button>
      </div>
    </div>

    <div class="editar-cliente">
      <PDialog :showHeader=false :closable="false" v-model:visible="popup" :modal="true" >
        <div class="titulo-popup-finalizado"> Deseja editar as informações do cliente? </div>

          <div class="botoes-popup">
            <div>
              <g-button 
              tipo="cinza"
              negritoTexto 
              largura="200px" 
              altura="35px" 
              @click="fechaPopup"
              > 
                NÃO 
              </g-button>
            </div>
            <div>
              <g-button 
              tipo="amarelo"
              negritoTexto
              largura="200px" 
              altura="35px"
              @click="edicaoCliente"
              >
                SIM
              </g-button>
            </div>
          </div>
      </PDialog>
    </div>

</template>

<script>
import InfoFrete from './InfoFrete.js'
export default InfoFrete
</script>

<style scoped>
.escoder{
  display: none;
}


.radioButton-container {

  padding-top: 1rem;
  display: flex;
  height: 2rem;
  gap: 10%;
  width: 100%;
  margin: 0 auto;
}


.titulo-conteudo-fluxos {
  margin-top: 20px;
  margin-bottom: 10px;
  display: flex;
  align-items: left;
}


.subtitulo {
  margin-top: 10px;
  margin-bottom: 5px;
  font-family: "MontSerrat";
  color: #8a8a8a;
  font-size: 16px;
}


.endereco-entrega {
  margin-top: 50px;
  margin-bottom: 5px;
  font-family: "MontSerrat";
  color: #8a8a8a;
  font-size: 16px;
  text-align: left;
}


.p-inputtext {
  width: 100%;
}


.titulostep {
  margin-top: 15px;
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 20px;
  font-weight: bold;
}

.uf {
  margin-right: 15px;
  grid-area: 1/2/1/2;
  width:120px;
}


.bairro {
  grid-area: 1 / 1 / 2 / 2;
}


.input {
  width: 100%;
}

.cidadeestado{
    display: flex;
  }

.endereco{
 grid-area: 2/2/2/4;
}

.cidade{
  width: 80%;
}

.Editar-SIM-NAO {  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 0px 10px;
  grid-auto-flow: row;
  grid-template-areas:
    "Editar-nao Editar-sim";
}

.Editar-nao { grid-area: Editar-nao; }

.Editar-sim { grid-area: Editar-sim; }

.conteudo-popup-edicao{
  font-family: "MontSerrat";
  color: #4f2c19;
  font-size: 18px;
  margin-top: 1rem ;
  margin-bottom: 2rem;
}


@media (min-width: 310px) {
  .cliente-info {  display: grid;
    height: 117px;
    grid-template-columns: 0.5fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-auto-columns: 1fr;
    gap: 10px 10px;
    grid-auto-flow: row;
    grid-template-areas:
      "cod-cliente nome-cliente"
      "editar-button editar-button";
  }

  .cod-cliente { grid-area: cod-cliente; }

  .nome-cliente { grid-area: nome-cliente; align-self: end;}

  .editar-button { grid-area: editar-button;  }

.bordas{
  padding-right: 15px;
  padding-left: 15px;
}

.btnAvancarVoltar {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column-reverse;
  column-gap: 50px;
  row-gap: 15px;
  margin-top: 60px;
}
}


@media (min-width: 368px) {

.cliente-info {  display: grid;
  height: 117px;
  grid-template-columns: 0.5fr 1fr;
  grid-template-rows: 1fr 1fr;
  grid-auto-columns: 1fr;
  gap: 10px 10px;
  grid-auto-flow: row;
  grid-template-areas:
    "cod-cliente nome-cliente"
    "editar-button editar-button";
}

.cod-cliente { grid-area: cod-cliente; }

.nome-cliente { grid-area: nome-cliente; align-self: end;}

.editar-button { grid-area: editar-button;  }
}


@media (min-width: 600px) {
.btnAvancarVoltar {
  flex-direction: row;
}
}


@media (min-width: 801px) {
  .frete-campo {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    grid-column-gap: 10px;

  }
  .radioButton-container {
    padding-top: 1rem;
    display: flex;
    height: 2rem;
    gap: 10%;
    width: 100%;
    margin: 0 auto;
  }

  .transportadora {
    grid-area: 3 / 3 / 3 / 3;
  }

  .complemento{
  grid-area: 3/ 1/ 3/ 3;
  }

.cep{
  grid-area: 2/ 1/ 2/ 2;
}

.cliente{
width: 100%px;
}

}


@media (min-width: 1025px) {
.bordas{
padding-right: 40px;
padding-left: 40px;
}

.cliente-info{
    padding-top: 3rem;
    display: grid;
    grid-template-columns: 0.5fr 1fr 0.1fr;
    grid-template-rows: 1fr;
    grid-auto-columns: 1fr;
    gap: 0px 15px;
    grid-auto-flow: row;
    grid-template-areas: "cod-cliente nome-cliente editar-button";
}

.cod-cliente { grid-area: cod-cliente; align-self: end;}

.nome-cliente { grid-area: nome-cliente; }

.editar-button {
  grid-area: editar-button;
  display: flex;
  justify-content: end;
  align-self: end;
 }

.container-cliente-endereco {  display: grid;
  grid-template-columns: 0.6fr 1fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "option-sim-nao cliente-endereco";
}

.option-sim-nao { grid-area: option-sim-nao; }

.cliente-endereco { grid-area: cliente-endereco; }
}


@media (min-width: 1281px) {
  .bordas{
padding-right: 140px;
padding-left: 140px;
}

.cliente-info {
  padding-top: 3rem;
  display: grid;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  grid-auto-flow: row;
  grid-template-areas:
    "cod-cliente nome-cliente editar-button";
}


.nome-cliente { grid-area: nome-cliente; }

.editar-button {
  grid-area: editar-button;
  display: flex;
  justify-content: flex-start;
  align-self: end;
 }

.container-cliente-endereco {  display: grid;
  grid-template-columns: 0.8fr 1fr;
  grid-template-rows: 1fr;
  grid-auto-columns: 1fr;
  gap: 0px 0px;
  grid-auto-flow: row;
  grid-template-areas:
    "option-sim-nao cliente-endereco";
}

.option-sim-nao { grid-area: option-sim-nao; }

.cliente-endereco { grid-area: cliente-endereco; }


}


</style>
